import { render, staticRenderFns } from "./CommonTemplate.vue?vue&type=template&id=5d77021a&scoped=true"
import script from "./CommonTemplate.vue?vue&type=script&lang=js"
export * from "./CommonTemplate.vue?vue&type=script&lang=js"
import style0 from "./CommonTemplate.vue?vue&type=style&index=0&id=5d77021a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77021a",
  null
  
)

export default component.exports